import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Landing from './pages/Landing';
import Login from './components/landing/LoginScreen';
import Dashboard from './pages/Dashboard';
import Tachograph from './pages/Tachograph';
import TachographDetail from './pages/TachographDetail';
import Trips from './pages/Trips';
import Drivers from './pages/Drivers';
import ActiveOffers from './pages/ActiveOffers';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import Companies from './pages/Companies';
import Vehicles from './pages/Vehicles';
import DriverPortal from './pages/DriverPortal';
import ProtectedRoute from './components/ProtectedRoute';
import Register from './pages/auth/Register';
import GovPanel from './pages/GovPanel';
import CompanyRegister from './components/landing/RegisterScreen';
import CompanySettings from './pages/CompanySettings';

function Unauthorized() {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--color-bg)' }}>
      <div className="text-center p-8">
        <div className="text-6xl mb-4">🚫</div>
        <h1 className="text-2xl font-bold text-slate-800 mb-2">Åtkomst nekad</h1>
        <p className="text-slate-500 text-sm mb-6">Du har inte behörighet att se den här sidan.</p>
        <a href="/" className="btn-primary inline-flex">Till startsidan</a>
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/register-company" element={<CompanyRegister />} />
          <Route path="/unauthorized" element={<Unauthorized />} />

          {/* All authenticated users */}
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

          {/* Driver portal — driver role only */}
          <Route path="/driver-portal" element={
            <ProtectedRoute allowRoles={['driver']}>
              <DriverPortal />
            </ProtectedRoute>
          } />

          {/* Admin/operator dashboard pages */}
          <Route path="/dashboard" element={
            <ProtectedRoute allowRoles={['superadmin', 'admin', 'operator']}>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/tachograph" element={
            <ProtectedRoute allowRoles={['superadmin', 'admin', 'operator']}>
              <Tachograph />
            </ProtectedRoute>
          } />
          <Route path="/tachograph/:id" element={
            <ProtectedRoute allowRoles={['superadmin', 'admin', 'operator']}>
              <TachographDetail />
            </ProtectedRoute>
          } />
          <Route path="/trips" element={
            <ProtectedRoute allowRoles={['superadmin', 'admin', 'operator']}>
              <Trips />
            </ProtectedRoute>
          } />
          <Route path="/drivers" element={
            <ProtectedRoute allowRoles={['superadmin', 'admin', 'operator']}>
              <Drivers />
            </ProtectedRoute>
          } />
          <Route path="/company-settings" element={
            <ProtectedRoute allowRoles={['admin']}>
              <CompanySettings />
            </ProtectedRoute>
          } />
          <Route path="/vehicles" element={
            <ProtectedRoute allowRoles={['superadmin', 'admin', 'operator']}>
              <Vehicles />
            </ProtectedRoute>
          } />
          <Route path="/active-offers" element={
            <ProtectedRoute allowRoles={['superadmin', 'admin', 'operator']}>
              <ActiveOffers />
            </ProtectedRoute>
          } />

          {/* Superadmin only */}
          <Route path="/companies" element={
            <ProtectedRoute allowRoles={['superadmin']}>
              <Companies />
            </ProtectedRoute>
          } />
          <Route path="/gov-panel" element={
            <ProtectedRoute allowRoles={['superadmin']}>
              <GovPanel />
            </ProtectedRoute>
          } />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
